import React from 'react';
import TopBar from '../../Components/TopBar';
import Page from '../../Components/Containers/Page';
import CopyableValue from '../../Components/Formatting/CopyableValue';
import { useBalance } from '../../Data/Balance';
import { useShortenUrls } from '../../Data/ShortLinks';

const ReferAFriend = () => {
    const {balance} = useBalance();

    return (
        <>
            <TopBar left="BackBtn" title="Refer a Friend" />
            <Page>
                <div className="prose mb-5">
                    <p>
                        Refer a friend using your personal link below and we'll give them <strong className="text-brand">two months free Soapy Pro</strong>!
                    </p>

                    <p>
                        Plus - as a thank you for referring a friend, once they've used their free months and become a paying user - <strong className="text-brand">we'll give you two months free</strong> as well!
                    </p>

                    <p>
                        You can refer as many friends as you like, and for each one that becomes a paying user, you'll get two months free.
                    </p>

                    <p>
                        Just share your personal link with your friends and we'll take care of the rest.
                    </p>
                </div>

                {balance && <CopyableValue title="Your personal referral link"
                    value={`https://app.getsoapy.com/register/REFER-${balance.shortId}`}
                />}
                {balance && <ShortLink link={`https://app.getsoapy.com/register/REFER-${balance.shortId}`} />}
            </Page>
        </>
    )
}

const ShortLink = ({link}) => {
    const {shortUrls} = useShortenUrls({link});

    return <CopyableValue title="Short link"
        className="mt-4"
        value={shortUrls?.link ?? 'Loading...'}
    />
}

export default ReferAFriend;
